import React, { Component } from 'react';
import { Button, IconButton, withStyles, Grid, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
// import Program from './Program';
import MainContext from '../MainContext';
import MainProvider from '../MainProvider';
import ProgramDynamic from './ProgramDynamic';
import ProgramMob from './ProgramMob';

const styles = (theme) => ({
  dialogRoot: {
    minHeight: '80vh',
    maxHeight: '92vh',
    [theme.breakpoints.down('sm')]: {
      maxHeight: '100vh',
      margin: '0px',
    },
  },
  dialogTitle: {
    margin: '0',
    // padding: '8px 8px 0',
    fontSize: '20px',
    color: theme.palette.primary.main,
    textAlign: 'center',
    paddingBottom: '16px',
    // borderBottom: '2px solid #025a3c',

    borderBottom: 0,
    // borderColor: theme.palette.primary.main,
  },
  dialogTitleContent: {
    fontWeight: 'bold',
    margin: '0 15px',
    paddingTop: '1em',
    paddingBottom: '1.5em',
    [theme.breakpoints.down('sm')]: {
      padding: '0.6em',
      fontSize: '16px',
    },
  },
  dialogContent: {
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      padding: '8px',
    },
  },
  dialogActions: {
    borderTop: '1px solid #ebebeb',
    margin: '0 24px',
    textAlign: 'center',
    display: 'none',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  contents: {
    padding: theme.spacing(1),
  },
  msgImg: {
    width: '100%',
    height: 'auto',
  },
  tableHead: {
    background: '#f3f3f3',
    width: '160px',
    borderTop: '1px solid #e0e0e0',
    borderLeftWidth: '0px',
    borderRightWidth: '0px',

    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  tableContent: {
    borderLeftWidth: '0px',
    borderRightWidth: '0px',
    width: '20%',
    marginRight: '2px',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
});

class ProgramDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      matches: window.matchMedia('(max-width:960px)').matches,
    };
  }

  render() {
    const { classes, open, onClose } = this.props;
    return (
      <MainProvider>
        <Dialog
          fullWidth={true}
          maxWidth={'lg'}
          onClose={onClose}
          aria-labelledby="welcome-msg-dialog"
          open={open}
          // disableBackdropClick={disableBackdrop}
          // disableEscapeKeyDown={disableBackdrop}
          className={classes.dialogRoot}
        >
          <DialogTitle className={classes.dialogTitle} onClose={onClose}>
            {/* <div className={classes.dialogTitleContent}>Program at a Glance</div>
            <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon />
            </IconButton> */}

            <Grid container justifyContent="center" alignContent="center">
              <Grid container item xs={1} />
              <Grid container justifyContent="center" alignContent="center" item xs={10}>
                <Grid container justifyContent="center">
                  <Typography
                    style={{
                      color: this.props.theme.palette.primary.main,
                      fontWeight: 'bold',
                      fontSize: this.state.matches ? '18px' : '22px',
                      lineHeight: this.state.matches ? 1 : '',
                    }}
                  >
                    VOD 다시보기
                  </Typography>
                </Grid>
                <Grid container justifyContent="center" style={{ padding: this.state.matches ? '2vh' : 0 }}>
                  {/* <Typography> Click 'Live' button to join the session</Typography> */}
                </Grid>
              </Grid>
              <Grid container justifyContent="center" alignContent="center" item xs={1}>
                {!this.state.matches && (
                  <IconButton
                    onClick={onClose}
                    className={classes.closeBtn}
                    // style={{ position: 'absolute' }}
                  >
                    <CloseIcon size={30} />
                  </IconButton>
                )}
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            {this.state.matches ? (
              // **KSIC2022 CUSTOM: 웹은 <Program> 스타일, 모바일은 <ProgramDynamic> 스타일
              <MainContext.Consumer>{(value) => <ProgramMob value={value} />}</MainContext.Consumer>
            ) : (
              // <MainContext.Consumer>{(value) => <Program value={value} />}</MainContext.Consumer>
              <MainContext.Consumer>{(value) => <ProgramDynamic value={value} />}</MainContext.Consumer>
            )}

            {/* <MainContext.Consumer>{(value) => <Program value={value} />}</MainContext.Consumer> */}
          </DialogContent>
          <DialogActions className={classes.dialogActions}>
            <Button onClick={onClose} style={{ color: '#000000', fontSize: 'large' }}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </MainProvider>
    );
  }
}

export default withStyles(styles, { withTheme: true })(ProgramDialog);
